import React from "react";
import { useTranslation } from "react-i18next";
import realEstateImg from "../../Assets/ServiceImg/realstate.webp"; // Imagen del servicio
import realEstatemenubg from "../../Assets/ServiceImg/realstate-bg.webp"; // Imagen de fondo de las preguntas
import realEstatequestionsbg from "../../Assets/ServiceImg/realstate-qbg.webp"; // Imagen de fondo de las preguntas
import Contact from "../Home/Contact";
import ServiceInfo from "./ServiceInfo";
import Card from "react-bootstrap/Card";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

import Seoimg from "../../Assets/ServiceImg/realstate.webp";

const RealEstate = () => {
   const { t } = useTranslation();

   const location = useLocation();
   const selectedLanguage = location.pathname.startsWith("/en") ? "en" : "es";

   const seoTranslations = {
      es: {
         title: "Fotografía y Vídeo Inmobiliario con Drones | Joan Company",
         description:
            "Resalta cada propiedad con tomas aéreas profesionales. Fotografía y vídeo con drones para inmobiliarias en Mallorca: planificación, vuelo y edición.",
         keywords:
            "fotografía inmobiliaria con drones, vídeo inmobiliario con drones, servicios con drones, grabación con drones, filmación con drones, fotografía aérea, videografía aérea",
         canonical: "https://www.joancompany.es/drones-inmobiliaria",
      },
      en: {
         title: "Real Estate services with Drones | Joan Company",
         description:
            "Highlight every property with professional aerial shots. Real estate photography and video with drones: planning, flight, and editing.",
         keywords:
            "real estate photography with drones, real estate video with drones, drone services, aerial photography, aerial videography",
         canonical: "https://www.joancompany.es/en/drones-inmobiliaria",
      },
   };

    return (
       <div className="service-container">
          <Helmet>
             <title key="title">
                {seoTranslations[selectedLanguage].title}
             </title>
             <meta
                key="description"
                name="description"
                content={seoTranslations[selectedLanguage].description}
             />
             <meta
                key="keywords"
                name="keywords"
                content={seoTranslations[selectedLanguage].keywords}
             />
             <link
                rel="canonical"
                href={seoTranslations[selectedLanguage].canonical}
             />
             <meta property="og:image" content={Seoimg} />
             <meta
                property="og:title"
                content={seoTranslations[selectedLanguage].title}
             />
             <meta
                property="og:description"
                content={seoTranslations[selectedLanguage].description}
             />
             <link rel="image_src" href={Seoimg} />
             <link
                rel="alternate"
                href="https://www.joancompany.es/drones-inmobiliaria"
                hreflang="es"
             />
             <link
                rel="alternate"
                href="https://www.joancompany.es/en/drones-inmobiliaria"
                hreflang="en"
             />
             <html lang={selectedLanguage} />
          </Helmet>

          <ServiceInfo
             title={t("real_estate_services")}
             image={realEstatemenubg}
             subtitle={t("real_estate_services_desc")}
             description={t("real_estate_services_desc")}
          />
          <Card
             className="quote-card-view"
             id="service-info-card"
          >
             <Card.Body>
                <div className="service-info-content-container">
                   <div className="service-info-content">
                      <h3>{t("real_estate_services_subtitle")}</h3>
                      <div
                         dangerouslySetInnerHTML={{
                            __html: t("real_state_services_info"),
                         }}
                      />
                   </div>
                   <div className="service-info-image">
                      <img
                         src={realEstateImg}
                         alt={t("real_estate_services")}
                         title={t("real_estate_services")}
                         loading="lazy"
                      />
                   </div>
                </div>
             </Card.Body>
          </Card>
          <div
             className="service-questions"
             style={{ backgroundImage: `url(${realEstatequestionsbg})` }}
          >
             <div className="service-questions-container">
                <div
                   dangerouslySetInnerHTML={{
                      __html: t("real_estate_services_questions"),
                   }}
                />
             </div>
          </div>
          <Contact />
       </div>
    );
};

export default RealEstate;
